"use client";
import React from "react";
import { cn } from "@/utils/utils";
import LinkElement from "@/components/LinkElement";

type Props = {
  link: string;
  total: number;
  limit: number;
  scroll?: boolean;
  className?: string;
};

export default function LoadMoreButton({
  link,
  total,
  limit,
  scroll = true,
  className,
}: Props) {
  return (
    <>
      {total > limit && (
        <LinkElement
          href={link}
          scroll={scroll}
          className={cn(
            "text-sm border border-gray-500 px-4 py-2 w-[190px] h-[34px] whitespace-nowrap rounded flex items-center justify-center hover:text-red-500 hover:border-red-500 transition-all",
            className
          )}
        >
          Xem thêm
        </LinkElement>
      )}
    </>
  );
}
